module.exports = __webpack_public_path__ + "p5_img3.jpg?5d766a5657d7809e75c6d01518b48fd2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img3.jpg
// module id = 125
// module chunks = 0